/**
 * EliorGroup.Joyfood.B2B2C API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OrderItemOrderExportDto } from './orderItemOrderExportDto';
import { OrderShopServiceTimeSlotDto } from './orderShopServiceTimeSlotDto';
import { CustomerOrderExportDto } from './customerOrderExportDto';


export interface OrderExportDto { 
    id?: number | null;
    deliveryDate?: string;
    deliveryPlace?: string | null;
    deliveryTime?: string | null;
    notes?: string | null;
    created?: string;
    status?: number;
    serviceTypeId?: number;
    shopName?: string | null;
    customer?: CustomerOrderExportDto;
    orderItems?: Array<OrderItemOrderExportDto> | null;
    shopServiceTimeSlot?: OrderShopServiceTimeSlotDto;
}

